import type { IconData } from '@stacksjs/iconify-core'

export const coffeeMug: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M5.078 36.31c.15 4.652 3.207 8.132 7.849 8.465C14.81 44.91 17.14 45 20 45s5.19-.09 7.073-.225c4.642-.333 7.698-3.813 7.849-8.465c.048-1.478.078-3.233.078-5.31c0-5.568-.217-8.922-.411-10.813c-.137-1.328-1.072-2.34-2.392-2.535C30.164 17.35 26.42 17 20 17s-10.165.35-12.197.652c-1.32.195-2.255 1.207-2.392 2.535C5.217 22.077 5 25.432 5 31c0 2.077.03 3.832.078 5.31M35 22h2.632c2.733 0 5.105 1.862 5.288 4.589a36 36 0 0 1 0 4.822C42.737 34.138 40.365 36 37.632 36H35M25 3v7m-8-5v7\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default coffeeMug
